import * as React from 'react'
import { Card, WithStyles, CardContent, Typography, Theme, createStyles, withStyles, Chip } from '@material-ui/core'
import { formatDate } from 'src/core/i18n/date'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer/index'
import { compose } from 'redux'
import { WithToast } from 'src/type/lib/withToast'
import { withToast } from "src/shared/Toast"
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { withGlobalProgress } from '../GlobalProgress'
import { fetchNewsFeatured, fetchNewsFeaturedPrevent } from 'src/core/redux/action/newsAction'
import { convertUrlName, replaceDetteWithTaux } from 'src/shared/utils/helpers'
import Link from '../Link/Link'
import NewsShare from './NewsShare'
import { config } from 'src/conf/config'
import { get } from 'lodash'


const styles = (t: Theme) => createStyles({
    card: {
        display: 'flex',
    },
    cardWpr: {
        display: 'flex',
        alignItems: 'flex-end',
        width: '100%',
        height: '100%',
        minHeight: '300px',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        background: 'rgba(0,0,0,.6)'
    },
    newsTitle: {
        lineHeight: 'inherit',
        color: '#fff'
    },
    chip: {
        margin: '4px',
        fontSize: '0.75rem',
        height: '26px'
    },
    btnShare:{
        margin: '0 2px',
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.75
        }
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 'auto'
    },
})

interface IProps extends WithI18n,
  WithToast,
  WithGlobalProgress,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
    pathNews: string;
    criteria: any;
}


class NewsCardFeatured extends React.Component<IProps, any> {

  render() {
    const {classes, newsFeatured, pathNews, enterprise, mapName} = this.props
    const chips = get(newsFeatured, "category_actu")
    return (
        <>
        {newsFeatured &&
            <Link to={`${pathNews}/${newsFeatured.id}/${convertUrlName(newsFeatured.title)}`}>
                <Card className={classes.card}>
                    <div 
                        className={classes.cardWpr}
                        style={{backgroundImage: `url(${newsFeatured.img_url ? newsFeatured.img_url : config.IMG_BASE_PATH + "/news-default.jpg"})`}}
                    >
                        <div className={classes.details}>
                            <CardContent>
                                <Typography variant="h6" gutterBottom className={classes.newsTitle} key={`news-card-title-${newsFeatured.id}`} >
                                    {(mapName && chips && chips.length > 0) && 
                                        chips.split(",").filter(c => c !== "economique").map(c => (
                                            <Chip key={c} label={replaceDetteWithTaux(mapName.get(c))} className={classes.chip} />
                                        ))
                                    }
                                    {newsFeatured.title}
                                </Typography>
                                <Typography variant="caption" gutterBottom className={classes.newsTitle} key={`news-card-author-${newsFeatured.id}`} style={{color: '#fff'}}>
                                    {formatDate(newsFeatured.publish_at)}
                                </Typography>
                            </CardContent>
                            
                            {!enterprise &&
                                <NewsShare post={newsFeatured}/>
                            }
                        </div>
                    </div>
                </Card>
            </Link>
        }
        {!newsFeatured &&
            <div className="padding-box">
                <Typography variant="caption" align="center" className="text-italic">Aucune actualité mise en avant disponible</Typography>
            </div>
        }
        </>
    )
  } 

  componentDidMount() {
    const { getNewsFeatured, criteria } = this.props
    getNewsFeatured(criteria).then(res => {
        /* news featured must before current date 2 weeks
        if(moment(res.publish_at).isBefore(moment().subtract(14, 'days')) === true){
            fetchNewsFeaturedPrevent(criteria)
        }
        */
    }).catch(err => {
        // fetchNewsFeaturedPrevent(criteria)
    })
  }

}

const state2props = (state: RootState) => ({
    mapName: state.utils.mapCategories,
    newsFeatured: state.newsFeatured.entity,
    enterprise: state.accountInfo.enterpriseSelected,
})

const dispatch2props = (dispatch: any, ownProps: any) => ({
    getNewsFeatured: (criteria: any) => dispatch(fetchNewsFeatured(criteria)),
    fetchNewsFeaturedPrevent: (criteria: any) => dispatch(fetchNewsFeaturedPrevent(criteria))
})

export default compose(
  withI18n,
  withStyles(styles),
  withGlobalProgress,
  withToast,
  connect(state2props, dispatch2props),
)(NewsCardFeatured)



// WEBPACK FOOTER //
// ./src/shared/News/NewsCardFeatured.tsx